module.exports = __webpack_public_path__ + "f43c47b3f1c6ba63364230328c8406d1.fbx";